module.exports = __webpack_public_path__ + "img/red-flag.78b22fd0.svg";